import React from 'react'
import { debounce } from 'lodash'
import ServiceFormPagerView from './ServiceFormPager.view'
import { toastr } from 'react-redux-toastr'
import { I18n } from 'react-redux-i18n'
import moment from 'moment'
import { showExtraChargeModalIfNeeded } from '../ExtraCharge/index'
import ExportDialog from './ExportDialog'
import { createDateRange } from '../../utils/dateUtils'

export default class ServiceFormPagerContainer extends React.Component {
  state = {
    pageNumber: undefined,
    showExportDialog: false,
  }

  constructor() {
    super()
    this.pageChange = debounce(this.pageChange, 500)
  }

  componentDidMount() {
    this.addKeyListeners()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentPage !== this.state.pageNumber) {
      this.setState({
        pageNumber: nextProps.currentPage,
      })
    }
  }

  addKeyListeners() {
    document.addEventListener('keydown', this.keyboardEventListener)
  }

  removeKeyListeners() {
    document.removeEventListener('keydown', this.keyboardEventListener)
  }

  keyboardEventListener = (keyboardEvent) => {
    if (keyboardEvent.altKey) return
    switch (keyboardEvent.key) {
      case 'ArrowRight':
        this.goNextPage()
        break
      case 'ArrowLeft':
        this.goPrevPage()
        break
      default:
        break
    }
  }

  goPrevPage = () => {
    this.goToPage(this.state.pageNumber - 1)
  }

  goNextPage = () => {
    this.goToPage(this.state.pageNumber + 1)
  }

  hasPrevPage = () => this.props.currentPage > 1
  hasNextPage = () => this.props.currentPage < this.props.totalPage

  handlePageChange = (pageNumberText) => {
    const pageNumber = pageNumberText ? Number(pageNumberText) : undefined
    this.setState((state) => ({
      ...state,
      pageNumber,
    }))
    this.pageChange(pageNumber)
  }

  pageChange = (pageNumber) => {
    this.goToPage(pageNumber)
  }

  goToPage = (pageNumber) => {
    if (pageNumber && pageNumber > 0 && pageNumber <= this.props.totalPage) {
      this.props.fetchServiceTxnBySeq(pageNumber)
    } else {
      this.setState((state) => ({
        ...state,
        pageNumber: this.props.currentPage,
      }))
    }
  }

  submiting = false

  handleFormSubmit = (serviceTxn) => {
    if (this.submiting) return
    const submitAction = () => {
      this.submiting = true
      this.props.updateServiceTxnForm(serviceTxn, {
        onResponse: this.handleUpdateServiceTxnResponse,
      })
    }

    showExtraChargeModalIfNeeded(serviceTxn, submitAction)
  }

  handleUpdateServiceTxnResponse = (response) => {
    if (response.ok) {
      toastr.success('Save completed')
      if (this.hasNextPage()) this.goNextPage()
      else {
        const { dateValue } = this.props
        const dateText = dateValue.isSame(moment(), 'day')
          ? 'today'
          : dateValue.format(I18n.t('date.display'))
        toastr.info(
          `You've completely fill all of service transaction for ${dateText}`,
        )
      }
    } else {
      toastr.error('Error', 'something went wrong please try again')
    }
    this.submiting = false
  }

  handleViewServiceTxnBySeq = () => {
    // Convert dateValue to startDate/endDate using user's timezone
    const dateRange = createDateRange(this.props.dateValue)

    const url = new URL('/report/web', window.location.href)
    url.searchParams.set('name', 'serviceTxnReport')
    url.searchParams.set('startDate', dateRange.start)
    url.searchParams.set('endDate', dateRange.end)
    url.searchParams.set('seq', this.state.pageNumber)
    if (this.props.searchArchived) {
      url.searchParams.set('source', 'archived')
    }
    window.open(url.href, '_blank')
  }

  isNeedWorkSheet = () => {
    return this.props.serviceTxn ? this.props.serviceTxn.needWorkSheet : false
  }

  handleExportButtonClick = () => {
    this.setState({ showExportDialog: true })
  }

  handleCloseExportDialog = () => {
    this.setState({ showExportDialog: false })
  }

  render() {
    return (
      <div>
        <ServiceFormPagerView
          pageNumber={this.state.pageNumber}
          totalPage={this.props.totalPage}
          totalCount={this.props.totalCount}
          onPageChange={this.handlePageChange}
          onViewServiceTxnBySeq={this.handleViewServiceTxnBySeq}
          onExportButtonClick={this.handleExportButtonClick}
          isNeedWorkSheet={this.isNeedWorkSheet()}
          dateValue={this.props.dateValue}
          onDateChange={this.props.onDateChange}
          searchArchived={this.props.searchArchived}
          onSearchArchivedChange={this.props.onSearchArchivedChange}
          goNextPage={this.goNextPage}
          goPrevPage={this.goPrevPage}
          hasPrevPage={this.hasPrevPage()}
          hasNextPage={this.hasNextPage()}
          currentServiceTxn={this.props.serviceTxn}
          onFormSubmit={this.handleFormSubmit}
          auth={this.props.auth}
        />
        <ExportDialog
          show={this.state.showExportDialog}
          onHide={this.handleCloseExportDialog}
          dateValue={this.props.dateValue}
          jwt={this.props.jwt}
          searchArchived={this.props.searchArchived}
        />
      </div>
    )
  }
}
